import { render, staticRenderFns } from "./dj-drawer-header.vue?vue&type=template&id=dd48f6f0&scoped=true&"
import script from "./dj-drawer-header.vue?vue&type=script&lang=js&"
export * from "./dj-drawer-header.vue?vue&type=script&lang=js&"
import style0 from "./dj-drawer-header.vue?vue&type=style&index=0&id=dd48f6f0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd48f6f0",
  null
  
)

export default component.exports